import type { WidgetPreset } from "../types";
import templateHtml from "./template.html?raw";

export const QUICK_WIN: WidgetPreset = {
  id: "quick-win",
  label: "Quick Win 🏆",
  defaultWidth: 140,
  defaultHeight: 152,
  html: templateHtml,
};
